module.exports = __webpack_public_path__ + "img/3.30e72541.jpg";